import { WidgetType, WidgetOption } from '@/types'
import input from '../input'
import WidgetTextarea from './WidgetTextarea.vue'

/** 多行文本 */
export default {
  ...input,
  key: 'textarea',
  name: '多行文本',
  type: WidgetType.TEXTAREA,
  icon: 'fa-icon-widget-textarea',
  height: 50,
  componentExtend: WidgetTextarea
} as WidgetOption
